<template>

  <div class="slide" :style="{backgroundImage: 'url('+background+')'}">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="box">
            <h3 class="heading" v-html="heading"></h3>
            <p class="sub-heading" v-html="subHeading"></p>
            <p class="content" v-html="content"></p>
            <button class="button">Learn More</button>
          </div>
        </div>
      </div>
    </div>
    <div class="overlay"></div>
  </div>
</template>

<script>
  export default {
    name: 'hero-slider',
    props: [
      'heading',
      'subHeading',
      'content',
      'background',
    ],
    data () {
      return {
      }
    },
    methods: {
    },
    created() {

    }
  }
</script>

<style scoped lang="sass">
  .slide
    color: white
    background-repeat: no-repeat
    background-position: center center
    background-size: cover
    .container
      position: relative
      z-index: 2
      .row
        .box
          margin: 0 auto
          max-width: 640px
          background: rgba(0,0,0,.3)
          padding: 20px
          position: relative
          border-radius: 10px
          letter-spacing: 1px
          @media screen and (max-width: 767px)
            text-align: center
          h3
            font-size: 3.5em
            margin: 0
            font-weight: 600
            color: white
            .highlight
              color: limegreen
            @media screen and (max-width: 767px)
              font-size: 1.5em
          .sub-heading
            font-weight: 300
            color: white
            font-size: 2em
            margin: 30px 0
            @media screen and (max-width: 767px)
              font-size: 1em
          .content
            font-size: 1em
            color: white
            margin: 20px 0
            @media screen and (max-width: 767px)
              font-size: 12px
              font-weight: 300
          .button
            border: 2px solid limegreen
            border-radius: 3px
            background: transparent
            color: limegreen
            padding: 10px 30px
            transition: 300ms
            &:hover
              background: limegreen
              color: white
    .overlay
      position: absolute
      background: rgba(0,0,0,.3)
      top: 0
      bottom: 0
      left: 0
      right: 0
      z-index: 1
</style>



// WEBPACK FOOTER //
// HeroSlider.vue?617a3df3